import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tw-flex tw-items-center tw-gap-2 tw-py-2 tw-pl-3 tw-pr-2 tw-rounded-lg tw-border lg:tw-border-black tw-border-white tw-cursor-pointer tw-bg-hover tw-justify-between sm:tw-justify-[unset]" };
const _hoisted_2 = { class: "tw-text-[13px] tw-font-semibold tw-text-nowrap tw-text-black" };
const _hoisted_3 = { style: { "font-size": "1.25em", "vertical-align": "middle" } };
const _hoisted_4 = {
    style: { "margin-left": "6px" },
    class: "lg:tw-text-black tw-text-white tw-text-base"
};
const _hoisted_5 = { class: "tw-text-sm tw-cursor-pointer" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 0 };
import { computed, ref } from 'vue';
import { Popover, PopoverContent, PopoverTrigger, } from '@/components/ui/popover/index';
import { setAndPersistLocale, i18n } from '@/i18n';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LangPopover',
    setup(__props) {
        const currentLang = computed(() => i18n.global.locale.value);
        const popoverOpen = ref(false);
        function handleSelect(lang) {
            setAndPersistLocale(lang);
            popoverOpen.value = false;
        }
        return (_ctx, _cache) => {
            const _component_Icon = _resolveComponent("Icon");
            return (_openBlock(), _createBlock(_unref(Popover), {
                open: popoverOpen.value,
                "onUpdate:open": _cache[2] || (_cache[2] = ($event) => ((popoverOpen).value = $event))
            }, {
                default: _withCtx(() => [
                    _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("p", _hoisted_2, [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(currentLang.value === 'ar' ? '🇸🇦' : '🇬🇧'), 1),
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(currentLang.value === 'ar' ? 'Arabic' : 'English'), 1)
                                ]),
                                _createVNode(_component_Icon, {
                                    name: "Globe",
                                    size: 18,
                                    class: "tw-text-muted"
                                })
                            ])
                        ]),
                        _: 1
                    }),
                    _createVNode(_unref(PopoverContent), { class: "tw-w-[160px] tw-py-2 tw-px-0 tw-rounded-lg !tw-z-[999]" }, {
                        default: _withCtx(() => [
                            _createElementVNode("ul", _hoisted_5, [
                                _createElementVNode("li", {
                                    class: _normalizeClass(["tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 tw-transition-all hover:tw-bg-hover", { 'tw-font-bold': currentLang.value === 'ar' }]),
                                    onClick: _cache[0] || (_cache[0] = ($event) => (handleSelect('ar')))
                                }, [
                                    _cache[4] || (_cache[4] = _createElementVNode("span", { style: { "font-size": "1.25em", "vertical-align": "middle" } }, "🇸🇦", -1)),
                                    _createElementVNode("span", {
                                        style: _normalizeStyle(currentLang.value === 'ar'
                                            ? 'color: #82b132; margin-left: 6px;'
                                            : 'margin-left: 6px;')
                                    }, "Arabic", 4),
                                    (currentLang.value === 'ar')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _cache[3] || (_cache[3] = [
                                            _createElementVNode("i", { class: "fas fa-check tw-text-[#82b132]" }, null, -1)
                                        ])))
                                        : _createCommentVNode("", true)
                                ], 2),
                                _createElementVNode("li", {
                                    class: _normalizeClass(["tw-flex tw-items-center tw-gap-2 tw-px-5 tw-py-2 tw-transition-all hover:tw-bg-hover", { 'tw-font-bold': currentLang.value === 'en' }]),
                                    onClick: _cache[1] || (_cache[1] = ($event) => (handleSelect('en')))
                                }, [
                                    _cache[6] || (_cache[6] = _createElementVNode("span", { style: { "font-size": "1.25em", "vertical-align": "middle" } }, "🇬🇧", -1)),
                                    _createElementVNode("span", {
                                        style: _normalizeStyle(currentLang.value === 'en'
                                            ? 'color: #82b132; margin-left: 6px;'
                                            : 'margin-left: 6px;')
                                    }, "English", 4),
                                    (currentLang.value === 'en')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _cache[5] || (_cache[5] = [
                                            _createElementVNode("i", { class: "fas fa-check tw-text-[#82b132]" }, null, -1)
                                        ])))
                                        : _createCommentVNode("", true)
                                ], 2)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["open"]));
        };
    }
});
